import {
  FOLDER_CREATED,
  FOLDER_DELETED,
  FOLDER_RENAMED,
  FOLDERS_SET,
  FOLDER_ANNOTATION_CHANGED,
  FOLDER_DECISION_DELETED,
} from '../action-types';
import { FoldersReducerType } from '../foldersState.types';
import { FolderActions } from '../actions';

const initialState: FoldersReducerType = {
  folders: {},
  decisionsCountByFolder: {},
  foldersLoaded: false,
  orderChrono: [],
  orderByName: [],
};

export function foldersReducer(
  state: FoldersReducerType = initialState,
  action: FolderActions,
) {
  switch (action.type) {
    case FOLDERS_SET: {
      const { folders, orderByName, decisionsCountByFolder } = action.payload;
      const newFolders = { ...state.folders, ...folders };
      return {
        ...state,
        folders: newFolders,
        decisionsCountByFolder,
        foldersLoaded: true,
        orderChrono: Object.keys(newFolders),
        orderByName,
      };
    }
    case FOLDER_CREATED: {
      const { folder } = action.payload;
      return {
        ...state,
        folders: {
          ...state.folders,
          [folder.folderKey]: {
            ...folder,
            numberOfDecision: 0,
            folderAnnotation: '',
          },
        },
        decisionsCountByFolder: {
          ...state.decisionsCountByFolder,
          [folder.folderKey]: 0,
        },
        orderChrono: [folder.folderKey].concat(state.orderChrono),
        orderByName: [folder.folderKey].concat(state.orderByName),
      };
    }
    case FOLDER_RENAMED: {
      const { title, folderKey } = action.payload;
      return {
        ...state,
        folders: {
          ...state.folders,
          [folderKey]: { ...state.folders[folderKey], title },
        },
      };
    }
    case FOLDER_DELETED: {
      const { folderKey } = action.payload;
      const newFolders = { ...state.folders };
      delete newFolders[folderKey];
      const newOrderChrono = state.orderChrono.filter(key => key !== folderKey);
      const newOrderByName = state.orderByName.filter(key => key !== folderKey);
      return {
        ...state,
        folders: newFolders,
        orderChrono: newOrderChrono,
        orderByName: newOrderByName,
      };
    }

    case FOLDER_DECISION_DELETED: {
      const { folderKey } = action.payload;
      return {
        ...state,
        decisionsCountByFolder: {
          ...state.decisionsCountByFolder,
          [folderKey]:
            state.decisionsCountByFolder[folderKey] > 0
              ? state.decisionsCountByFolder[folderKey] - 1
              : 0,
        },
      };
    }

    case FOLDER_ANNOTATION_CHANGED: {
      const { folderAnnotation, folderKey } = action.payload;
      return {
        ...state,
        folders: {
          ...state.folders,
          [folderKey]: { ...state.folders[folderKey], folderAnnotation },
        },
      };
    }

    default:
      return state;
  }
}
